import React, { useState } from "react";
import axios from "axios";

export default function AcceptanceLogicPage() {
  const [chargeID, setChargeID] = useState("");
  const [status, setStatus] = useState(null);
  const [errorData, setErrorData] = useState(null);
  const [merchantInfo, setMerchantInfo] = useState(null);
  const [information, setInformation] = useState(null);
  const [selectedRequest, setSelectedRequest] = useState(null); // For dialog
  const [dialogTitle, setDialogTitle] = useState("");

  function reesetButtonAction() {
    setInformation(null);
    setMerchantInfo(null);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    setErrorData(null);
    try {
      const res = await axios.post("https://tp-api.alsendi.me/acceptance-logic", {
        id: chargeID,
      });
      setInformation(res.data.acceptanceResponse);
      setMerchantInfo(res.data.merchantInfo);
    } catch (err) {
      console.error(err);
      setErrorData(err.message || "Error fetching status");
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Acceptance Logic Page</h1>
        <h4>Developed By Ali AlSendi</h4>
      </header>

      <main className="App-main">
        <div className="card-container2">
          {(!information && !merchantInfo) && (
            <form onSubmit={handleSubmit}>
              <div className="mb-4 w-full max-w-md">
                <label htmlFor="charge-id" className="block text-sm font-medium text-gray-700 mb-1">
                  Charge ID
                </label>
                <br /><br />
                <input
                  id="charge-id"
                  type="text"
                  value={chargeID}
                  onChange={(e) => setChargeID(e.target.value)}
                  placeholder="Enter Charge ID"
                  required
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150"
                />
              </div>
              <br />
              <button className="pay-button" type="submit">Get Information</button>
            </form>
          )}
          {merchantInfo && (<>
            <h2>Merchant Information</h2>
            <div style={{ textAlign: "left" }}>
              <strong>Merchant Name:</strong> {merchantInfo.name}<br/>
              <strong>Merchant Country:</strong> {merchantInfo.country}<br/>
              <strong>Business ID:</strong> {merchantInfo.business_id} <br/>
              <strong>Entity ID:</strong> {merchantInfo.entity_id} <br/>
              <strong>Is Marketplace:</strong> {merchantInfo.is_marketplace ? "yes": "no"} <br/>
              <strong>Is Acceptance Allowed:</strong> {merchantInfo.is_acceptance_allowed ? "yes": "no"} <br/>
              <strong>Is Payout Allowed:</strong> {merchantInfo.is_payout_allowed ? "yes": "no"} <br/>
              <strong>Technology Name:</strong> {merchantInfo.technologyInforomationResponse.name_en} <br/>
              <strong>Facilitator Name:</strong> {merchantInfo.facilitatorResponse.display_name} <br/>
              <strong>Merchant Permissions:</strong> {merchantInfo.initResponse.permissions.join(", ")} <br/>
            </div>
          </>)}
          {information && (
            <>
              <h2>Acceptance Logs</h2>
              <div className="y-scroll" style={{
                paddingBottom: "10px"
              }}>
                <table border="1" cellPadding="10" cellSpacing="0"  >
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>API/SDK</th>
                      <th>API Version</th>
                      <th>API Expiry</th>
                      <th>Device</th>
                      <th>IP Address</th>
                      <th>Live</th>
                      <th>Customer Checked</th>
                      <th>Key</th>
                      <th>Endpoint</th>
                      <th>API Controller</th>
                      <th>Permissions</th>
                      <th>Gateway Name</th>
                      <th>Merchant ID</th>
                      <th>Source ID</th>
                      <th>Sub Merchant Name</th>
                      <th>View Request</th>
                      <th>View Response</th>
                      <th>View Gateway Response</th>
                    </tr>
                  </thead>
                  <tbody>
                    {information.map((data, index) => (
                      <tr key={index}>
                        <td >{data.type}</td>
                        <td >{data.client.entry.name}</td>
                        <td >{data.headers.api_version}</td>
                        <td >{data.headers.expiry_at}</td>
                        <td >{data.client.device.type}</td>
                        <td >{data.client.location.ip}</td>
                        <td >{data.headers.live_mode ? "yes" : "no"}</td>
                        <td >{data.headers.customer_checked ? "yes" : "no"}</td>
                        <td >{data.headers.authorization}</td>
                        <td >{data.headers.api_endpoint}</td>
                        <td >{data.headers.api_controller}</td>
                        <td >{data.headers.permissions}</td>
                        <td>{data.request.gateway?.name ?? ""}</td>
                        <td>{data.headers.txn_merchant_id}</td>
                        <td>{data.request.source?.id ?? ""}</td>
                        <td>{data.request.submerchant?.trading_name[0]?.text ?? data.response.gateway?.gateway_response?.order?.subMerchant?.tradingName ?? data.response.gateway?.gateway_response?.order?.subMerchant?.tradingName ?? ""}</td>
                        <td>
                          <button onClick={() => {
                            setSelectedRequest(data.request);
                            setDialogTitle("Request JSON");
                          }}>
                            Show JSON
                          </button>
                        </td>
                        <td>
                          {(data.response && data.response !== "") &&
                            <button onClick={() => {
                              setSelectedRequest(data.response);
                              setDialogTitle("Response JSON");
                            }}>
                              Show JSON
                            </button>
                          }
                        </td>
                        <td>
                          {(data.response.gateway?.gateway_response) &&
                            <button onClick={() => {
                              setSelectedRequest(data.response.gateway.gateway_response);
                              setDialogTitle("Gateway Response JSON");
                            }}>
                              Show JSON
                            </button>
                          }
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <br />
            </>
          )}

          {
            (information || merchantInfo) &&
            <button className="pay-button" onClick={reesetButtonAction}>Reset</button>
          }

          {status && (
            <div style={{ marginTop: "1rem", color: "green" }}>
              <strong>Status:</strong> {status}
            </div>
          )}

          {errorData && (
            <div style={{ marginTop: "1rem", color: "red" }}>
              <strong>Error:</strong> {errorData}
            </div>
          )}

          {/* JSON Dialog */}
          {selectedRequest && (
            <div className="dialog-overlay" style={overlayStyle}>
              <div className="dialog" style={dialogStyle}>
                <h3>{dialogTitle}</h3>
                <pre style={{ textAlign: "left", maxHeight: "300px", overflowY: "auto" }}>
                  {JSON.stringify(selectedRequest, null, 2)}
                </pre>
                <button onClick={() => {
                  setSelectedRequest(null);
                  setDialogTitle(""); // Reset title
                }}>Close</button>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

// Inline styles for the modal
const overlayStyle = {
  position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: "rgba(256,256,256,0.5)", display: "flex",
  justifyContent: "center", alignItems: "center", zIndex: 1000
};

const dialogStyle = {
  backgroundColor: "#282828", padding: "20px", borderRadius: "8px",
  width: "500px", maxHeight: "90vh", overflow: "auto", boxShadow: "0 2px 10px rgba(0,0,0,0.2)"
};
